module.exports = __webpack_public_path__ + "img/virtual_tour.a216ba51.jpg";